import { AxiosInstance } from "axios";

export function setupAuthInterceptor(api: AxiosInstance) {
  api.interceptors.request.use((config) => {
    const token = localStorage.getItem("verden-token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  });
}
